import classNames from "classnames";
import { forwardRef } from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: string;
}

const spriteSheetUrl = new URL("npm:bootstrap-icons/bootstrap-icons.svg", import.meta.url);

export const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon({ icon, className, ...props }, ref) {
  return (
    <svg ref={ref} className={classNames("bi ", className)} fill="currentColor" {...props}>
      <use href={spriteSheetUrl.href + "#" + icon} />
    </svg>
  );
});
